var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordSettingsIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".passwordSettingsIco_svg__a{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-940 -52)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "passwordSettingsIco_svg__a",
    width: 28,
    height: 28,
    rx: 2,
    transform: "translate(940 52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "passwordSettingsIco_svg__a",
    d: "M943.5 54.625h21v21h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.5 54.625h21v21h-21z",
    opacity: 0.87,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.25 61.625h-.875v-1.75a4.375 4.375 0 00-8.75 0v1.75h-.875a1.755 1.755 0 00-1.75 1.75v8.75a1.755 1.755 0 001.75 1.75h10.5a1.755 1.755 0 001.75-1.75v-8.75a1.755 1.755 0 00-1.75-1.75zm-7.875-1.75a2.625 2.625 0 015.25 0v1.75h-5.25zm7.875 12.25h-10.5v-8.75h10.5zM954 69.5a1.75 1.75 0 10-1.75-1.75A1.755 1.755 0 00954 69.5z",
    fill: "rgba(0,0,0,.87)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(954 66.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.25,
    cy: 5.25,
    r: 5.25,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95 5.591a2.856 2.856 0 00.022-.341 2.158 2.158 0 00-.026-.341l.739-.578a.181.181 0 00.044-.223l-.7-1.212a.178.178 0 00-.214-.079l-.871.35a2.563 2.563 0 00-.591-.341l-.131-.927a.175.175 0 00-.175-.149h-1.4a.17.17 0 00-.171.149l-.131.928a2.632 2.632 0 00-.591.341l-.871-.35a.173.173 0 00-.214.079l-.7 1.212a.17.17 0 00.044.223l.739.577a2.062 2.062 0 000 .682l-.739.578a.181.181 0 00-.044.223l.7 1.212a.178.178 0 00.214.079l.871-.35a2.563 2.563 0 00.591.341l.131.927a.178.178 0 00.171.149h1.4a.167.167 0 00.175-.149l.131-.928a2.632 2.632 0 00.591-.341l.871.35a.173.173 0 00.207-.078l.7-1.212a.17.17 0 00-.044-.223l-.731-.577zm-2.6.971A1.313 1.313 0 116.66 5.25a1.316 1.316 0 01-1.313 1.313z"
  })))));
}
export default SvgPasswordSettingsIco;